// extracted by mini-css-extract-plugin
export default {"header":"index_header_1OKM9 clearfix","logo":"index_logo_Siy3A"};